import React, { useEffect, useState, Suspense } from "react";
import { connect } from "react-redux";
import { Dialog, Paper, withStyles } from "@material-ui/core";
import { BackButton } from "../../sc-utilities";
import SecurazeSolutionForm from "./SecurazeSolutionForm";
import * as securazeSolutionActions from './store/securazeSolutionActions';
import { parseURL } from "../../sc-utilities";
import * as actions from '../ErasureMethod/store/erasureMethodActions';
import History from "../../../../src/History";
import * as Yup from "yup";
import { hasPermission } from "../../sc-utilities";
import AppLogoLoading from "../../sc-logo";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    }
});

const SecurazeSolutionDetails = (props) => {
    const { classes, activeCustomerID, permissions, translations, onCreateSecurazeSolution, onFetchSecurazeSolution, onUpdateSecurazeSolution, onListSupportedClientTypes } = props;
    const [securazeSolution, setSecurazeSolution] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const isEdit = window.location.href.includes("edit");
    const securazeSolutionId = (isEdit ? parseURL(window.location.href).SecurazeSolutionID : null);
    const [supportedClientTypesList, setListSupportedClientTypesList] = useState({ supportedClientTypes: []});
 
    useEffect(() => {
        const fetchData = async () => {
            setIsLoaded(false);
            const result = await onFetchSecurazeSolution({ SecurazeSolutionID: securazeSolutionId, ActiveCustomerID: activeCustomerID })
            setSecurazeSolution(result);
            setIsLoaded(true);
        }

        const fetchSupportedClientTypes = async () => {
            setIsLoaded(false);
            let supportedClientTypes = await onListSupportedClientTypes({ ActiveCustomerID: activeCustomerID });
            setListSupportedClientTypesList({ supportedClientTypes: supportedClientTypes});
            setIsLoaded(true);
        }

        isEdit && fetchData();
        fetchSupportedClientTypes();
    }, [onFetchSecurazeSolution, activeCustomerID, isEdit, securazeSolutionId, onListSupportedClientTypes]);

    const handleCreate = async (data) => {
        const createdData = { ...data };
        createdData.SupportedClientTypeIDs = createdData.SupportedClientTypeIDs.map((e) => e.value);
        if(createdData.Description === ""){
            delete createdData["Description"];
        }
        const result = await onCreateSecurazeSolution({ ...createdData, ActiveCustomerID: activeCustomerID});
        if (result) {
            History.goBack();
        }
    }

    const handleEdit = async (data) => {
        const editedData = { ...data };
        editedData.SupportedClientTypeIDs = editedData.SupportedClientTypeIDs.map((e) => e.value);
        if(editedData.Description === ""){
            delete editedData["Description"];
        }
        const result = await onUpdateSecurazeSolution({ ...editedData, ActiveCustomerID: activeCustomerID, SecurazeSolutionID: securazeSolutionId });
        if (result) {
            History.goBack();
        }
    }

    const showSupportedClientTypes = () => {
        let selectedSct = securazeSolution?.SupportedClientTypes.map((sct) => sct.SupportedClientTypeID);
        return supportedClientTypesList?.supportedClientTypes.filter((e) => selectedSct.includes(e.value));
    }

    const initialValues = {
        Key: securazeSolution?.Key || "",
        LongName: securazeSolution?.LongName || "",
        ShortName: securazeSolution?.ShortName || "",
        DedicatedFor: securazeSolution?.DedicatedFor || "all",
        Description: securazeSolution?.Description || "",
        SupportedClientTypeIDs: securazeSolution?.SupportedClientTypes ? showSupportedClientTypes() : []
    }

    const formSettings = {
        Validation: Yup.object().shape({
        Key: Yup.string().required(),
        LongName: Yup.string().required(),
        ShortName: Yup.string().required(),
        }),
        FormTitle: isEdit ? translations["edit_securaze_solution"] || "Edit securaze solution" : translations["create_securaze_solution"] || "Create securaze solution",
        ButtonSubmit: hasPermission(permissions, isEdit ? "securaze_solution_update" : "securaze_solution_create") ? {
            Title: isEdit ? translations["save"] || "SAVE" : translations["create"] || "Create",
            Color: 'primary'
        } : null,
    }

    const loadingSpinner = (
    <Dialog
        disableBackdropClick={true}
        disableEscapeKeyDown={false}
        open={isLoaded}
        PaperProps={{
        classes: {root: classes.loadingScreen}}}>
            <AppLogoLoading />
    </Dialog>)

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Suspense fallback={loadingSpinner}>
                {securazeSolution || !isEdit ?
                    <SecurazeSolutionForm
                        translations={translations}
                        permissions={permissions}
                        isEdit={isEdit}
                        handleSubmit={isEdit ? handleEdit : handleCreate}
                        securazeSolution={securazeSolution}
                        initialValues={initialValues}
                        formSettings={formSettings}
                        supportedClientTypes={supportedClientTypesList.supportedClientTypes}
                    /> : loadingSpinner}
            </Suspense>
        </Paper>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchSecurazeSolution: (params) => dispatch(securazeSolutionActions.fetchSecurazeSolution(params)),
        onCreateSecurazeSolution: (params) => dispatch(securazeSolutionActions.createSecurazeSolution(params)),
        onUpdateSecurazeSolution: (params) => dispatch(securazeSolutionActions.updateSecurazeSolution(params)),
        onListSupportedClientTypes: (data, option) => dispatch(actions.listSupportedClientTypes(data, option)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(SecurazeSolutionDetails));

